import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';
import { useCreateQuizModalStore } from '@/store';

const QuizService = sdk.getService('QuizService');

export const useGetAvailableQuizModes = () => {
  const { data: quizData } = useCreateQuizModalStore();

  const courseId = quizData?.courseId ?? null;
  const sectionIds = quizData?.sectionIds ?? [];

  const { isLoading, data, error } = useQuery({
    queryKey: ['quizzes', 'available-modes', courseId, JSON.stringify(sectionIds)],
    queryFn: () =>
      QuizService.getAvailableQuizModes({
        courseId: courseId || undefined,
        sectionIds: sectionIds.length ? sectionIds : undefined
      }),
    refetchOnMount: true
  });

  return {
    availableQuizModes: data,
    isLoading,
    error
  };
};
